import { FormService } from './FormService';

export class DespatchNcrService extends FormService {
    constructor() {
        super("DespatchNcrs");
    }
}